import ReactDOM from 'react-dom/client';
import { browser } from './browser';
import { checkAndHandleVersionUpdate } from './appVersionUpdate';
import { removeLegacyServiceWorkers } from './removeLegacyServiceWorkers';
import { registerAppServiceWorker } from './registerAppServiceWorker';
import { loadAdobeLaunch } from './loadAdobeLaunch';
import { cleanupCurrentBrowserCookies } from './browserCookieCleanup';
import './index.css';
import './styles/_reset.css';
import './styles/print.css';

const { shouldReload } = cleanupCurrentBrowserCookies();

if (shouldReload) {
  window.location.reload();
} else {
  loadAdobeLaunch();

  // The legacy Angular worker must be gone before ours registers, otherwise both compete
  // for control of the page during the same load.
  void (async () => {
    const reloading = await removeLegacyServiceWorkers();

    if (!reloading) {
      await registerAppServiceWorker();
    }
  })();

  // Check if the deployed version changed. If so, clear browser caches and
  // reload once — same behaviour as Angular's app-update.service.ts.
  checkAndHandleVersionUpdate();

  const App = browser();

  ReactDOM.createRoot(document.getElementById('root')!).render(<>{App}</>);
}
